import { render, staticRenderFns } from "./DimensionFilterEditor.vue?vue&type=template&id=2f9e816f&scoped=true"
import script from "./DimensionFilterEditor.vue?vue&type=script&lang=js"
export * from "./DimensionFilterEditor.vue?vue&type=script&lang=js"
import style0 from "./DimensionFilterEditor.vue?vue&type=style&index=0&id=2f9e816f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e816f",
  null
  
)

export default component.exports